import { useRef } from 'react';
import styled from '@emotion/styled';
import { useSetAtom } from 'jotai';
import { useTranslation } from 'next-i18next';
import { BOTTOM_TAB_BAR_HEIGHT } from 'src/components/BottomTabBar';
import Button from 'src/components/Button';
import useBodyScrollLock from 'src/hooks/useBodyScrollLock';
import useIsOpenModal from 'src/hooks/useIsOpenModal';
import useLogin from 'src/hooks/useLogin';
import { closeModalAtom } from 'src/stores/modal/atoms';
import { ModalType } from 'src/types/Modal';
import { hexToRgb } from 'src/utils/common';
import PermissionErrorGuide from './Guide';
const FullScreenContainer = styled.div<{
  isLogin: boolean;
}>`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(${({
  theme
}) => hexToRgb(theme.color.surfaceDeepFixed)}, 0.9);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 240px;
  z-index: 50;
  ${({
  theme,
  isLogin
}) => `
    ${theme.screenSize.tablet} {
      padding: 0 24px;
      /* 로그인 시 BottomTabBar가 있으므로 그 높이만큼 bottom 설정, 비로그인 시 safe-area 패딩 적용 */
      ${isLogin ? `bottom: calc(${BOTTOM_TAB_BAR_HEIGHT} + var(--sab));` : 'padding-bottom: var(--sab);'}
    }
  `}

  ${({
  theme
}) => theme.screenSize.mobile} {
    z-index: 51;
  }
`;
const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1;
`;
const Title = styled.div`
  color: ${({
  theme
}) => theme.color.contentBrightFixed};
  font-size: 60px;
  font-weight: 700;
  text-align: center;
  ${({
  theme
}) => theme.screenSize.tablet} {
    font-size: 26px;
  }
`;
const CloseButton = styled(Button)`
  margin-bottom: 65px;
  width: 312px;
  ${({
  theme
}) => theme.screenSize.tablet} {
    width: calc(100% - 48px);
    margin-bottom: 24px;
  }
`;
const PermissionErrorFullModal = () => {
  const {
    t
  } = useTranslation();
  const ref = useRef<HTMLDivElement>(null);
  useBodyScrollLock(ref);
  const isFaceAgeVerificationModalOpen = useIsOpenModal(ModalType.FACE_AGE_VERIFICATION);
  const {
    isLogin
  } = useLogin();
  const closeModal = useSetAtom(closeModalAtom);
  const handleClose = () => {
    closeModal(ModalType.ERROR);
  };
  return <FullScreenContainer ref={ref} isLogin={isLogin} data-sentry-element="FullScreenContainer" data-sentry-component="PermissionErrorFullModal" data-sentry-source-file="index.tsx">
      <ContentContainer data-sentry-element="ContentContainer" data-sentry-source-file="index.tsx">
        <Title data-sentry-element="Title" data-sentry-source-file="index.tsx">{t('CAMERA_ALLOW_TITLE')}</Title>
        <PermissionErrorGuide data-sentry-element="PermissionErrorGuide" data-sentry-source-file="index.tsx" />
      </ContentContainer>
      {/* 얼굴 인증 플로우는 서비스 이용을 위해 강제되기 때문에 이탈 수단 미제공 */}
      {!isFaceAgeVerificationModalOpen && <CloseButton variant='outlined' id='error-permission-close' onClick={handleClose}>
          {t('COMMON__CLOSE')}
        </CloseButton>}
    </FullScreenContainer>;
};
export default PermissionErrorFullModal;